import React from "react";
//styles
import "./Banner.scss";

export default function Banner(props) {
	const handleClick = (e) => {
		console.log(e);
		props.history.push("/invite-friends");
	};

	return (
		<div className={`banner container--default ${props.className}`} onClick={handleClick} style={{cursor : 'pointer'}}>
			<div className="banner__inner">
				<p>
					Get <strong>20% </strong>Off
				</p>
			</div>
		</div>
	);
}
